<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
  <CookieModal v-if="showModal" @closeCookies="handleModalClose" @acceptCookies="handleCookieAccept" @declineCookies="handleCookieDecline"/>
</template>

<script>
import NavBar from "@/components/standardComponents/NavBar.vue";
import BottomBar from "@/components/standardComponents/BottomBar.vue"
import CookieModal from "@/components/standardComponents/CookieModal.vue";
import Cookies from 'js-cookie';
import NormalPage from "@/NormalPage.vue";
/*import standalonePage from "@/StandalonePage.vue";*/

export default {
  name: 'App',
  data(){
    return{
      backgroundColorNow: '#8582d9',
      showModal: true,
    }
  },
  components: {
    NavBar,
    BottomBar,
    CookieModal,
  },
  methods: {
    handleCookieAccept(){
      Cookies.set('cookieConsent', 'accepted', { expires: 365 })
    },
    handleCookieDecline(){
      Cookies.set('cookieConsent', 'declined', { expires: 365 })
    },
    handleModalClose() {
      this.showModal = false;
    }
  },
  watch:{
    '$route' (){
      switch(this.$route.path){
        case '/':
          this.backgroundColorNow = '#2e424d'
          break;
        case '/StyleMaker':
            this.backgroundColorNow = '#dddddd';
          break;
        default:
          this.backgroundColorNow = '#4d6f80'
      }
    }
  },
  mounted() {
    if(Cookies.get('cookieConsent', 'accepted') || Cookies.get('cookieConsent', 'declined') ){
      this.showModal = false
    }
  },
  computed: {
    layoutComponent() {
      // Return the layout component based on the current route's meta property
      const layout = this.$route.meta.layout;
      return layout || NormalPage; // Default to MainLayout if no layout is specified
    },
  },
}
</script>

<style>
body{
  margin: 0;
  height: 100vh;
}
.wholeSite{
  width: 100%;
  background-color: #f7f2ea;
  background-image: url(http://www.transparenttextures.com/patterns/subtle-grunge.png);
  background-repeat: repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #db6457;
}
h1 {
  font-size: 2vw;
  font-family: "Oswald Bold", sans-serif;
  letter-spacing: -1px;
}
h2 {
  font-size: 1.5vw;
  font-family: "Oswald Bold", sans-serif;
  letter-spacing: -1px;
}
h3 {
  font-size: 1.4vw;
  font-family: "Oswald Bold", sans-serif;
  letter-spacing: -1px;
}
p {
  margin-top: 0.5vw;
  font-size: 1vw;
  font-family: "Crimson Text", serif;
}
button {
  font-size: 1vw;
  border-radius: 2vw;
  height: 2.5vw;
  width: 7.5vw;
  text-align: center;
  border: none;
  color: white;
  font-family: "Crimson Text", serif;
  background-color: #db6457;
}
button:hover {
  cursor: pointer;
}
select {
  font-size: 1vw;
  border-radius: .2vw;
  border: none;
  height: 2.5vw;
  text-align: center;
  background-color: white;
  color: #db6457;
  font-family: "Crimson Text", serif;
}
select:hover {
  cursor: pointer;
}
select:focus {
  color: white;
}
input {
  font-size: 1vw;
  height: 2vw;
  text-align: center;
  background-color: white;
  border: .2vw solid #db6457;
  border-radius: .5rem;
  color: #db6457;
  font-family: "Crimson Text", serif;
}
#app {
  text-align: center;
}
a {
  font-size: 1.2vw;
  font-family: "Oswald", sans-serif;
  text-decoration: none;
  color: black;
}
</style>
